<template>
  <v-navigation-drawer v-model="drawer" app class="bg-scoped-gray" temporary>
    <v-icon @click="toggleDrawer" class="burger-icon">{{ drawer ? 'mdi-close' : 'mdi-menu' }}</v-icon>

    <v-list outlined nav shaped class="drawer-content">
      <v-list-item class="mb-7" align="center">
        <v-col cols="12" class="pb-0">
          <v-icon :color="'#30a82d'">mdi-account-circle-outline</v-icon>
        </v-col>
        <v-col cols="12" class="pb-0">
          <span class="user-info">{{ userName }}</span>
        </v-col>
        <v-col cols="12" class="text-caption pt-2">
          <span class="user-info">{{ userPhoneNumber }}</span>
        </v-col>
      </v-list-item>

      <v-list-item v-for="(item, index) in navigationItems" :key="index"
                   @click="navigateTo(item.route)"
                   class="mb-2 rounded-lg primary--text"
                   lines="one"
                   :title="$t(item.titleKey)"
                   :prepend-icon="item.icon"
                   :class=" {'custom-icon' : item.route === $route.path}"
      >
        <template v-slot:prepend>
          <v-icon
              :color="item.route === $route.path ? '#ffffff' : '#30a82d'"
              size="30"
          >
            {{ item.icon }}
          </v-icon>
        </template>
      </v-list-item>
      <v-list-item
        class="mb-2 rounded-lg primary--text"
        lines="one"
        :title="$t('sidebar.logout')"
        prepend-icon="mdi-logout"
        @click="logout"
      >
        <template v-slot:prepend>
          <v-icon
            :color="'#30a82d'"
            size="30"
          />
        </template>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>

  <v-app-bar app class="bg-scoped-gray pr-4 pr-sm-6" elevation="0">
    <v-app-bar-nav-icon @click="toggleDrawer">
      <v-icon>mdi-menu</v-icon>
    </v-app-bar-nav-icon>
    <div class="logo-container"></div>
    <v-spacer></v-spacer>
    <LanguageSwitcher />
  </v-app-bar>

  <v-bottom-navigation
      class="bg-scoped-gray"
      v-show="isMobile">
    <v-btn @click="$router.push('/dashboard')">
      <v-icon
          :color="'/dashboard' === $route.path ? 'black' : '#30a82d'"
      >
        mdi-briefcase-account-outline
      </v-icon>
    </v-btn>

    <!-- <v-btn @click="$router.push('/payment-history')">
      <v-icon
          :color="'/payment-history' === $route.path ? 'black' : '#30a82d'"
      >
        mdi-format-list-bulleted
      </v-icon>
    </v-btn> -->

    <v-btn @click="$router.push('/investment-history')">
      <v-icon
          :color="'/investment-history' === $route.path ? 'black' : '#30a82d'"
      >
        mdi-text-box-outline
      </v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import { jwtDecoded } from '@/helpers';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'

export default {
  name: 'SideBar',
  components: { LanguageSwitcher },
  data() {
    return {
      drawer: false,
      isMobile: false,
      navigationItems: [
        {titleKey: 'sidebar.myAccount', icon: 'mdi-briefcase-account-outline', route: '/dashboard'},
        // {title: 'sidebar.paymentHistory', icon: 'mdi-format-list-bulleted', route: '/payment-history'},
        {titleKey: 'sidebar.myInvestments', icon: 'mdi-text-box-outline', route: '/investment-history'},
      ],
      userName: '',
      userPhoneNumber: ''
    };
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    navigateTo(route) {
      this.$router.push(route);
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 600;
    },
    parseJwtPayload() {
      const payload = jwtDecoded()

      if (payload) {
        this.userName = payload.fullName
        this.userPhoneNumber = payload.userUUID
      }
    },
    logout() {
      localStorage.removeItem('jwtToken');

      this.navigateTo('/')
    }
  },
  mounted() {
    this.checkScreenSize();

    window.addEventListener('resize', this.checkScreenSize);

    this.parseJwtPayload()
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
};
</script>

<style scoped>
.header-with-padding {
  padding-right: 8px;
}

.logo-container {
  width: 210px;
  height: 70px;
  background-image: url('../../public/logo_le.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.bg-scoped-gray {
  background: #f1f5fa;
}

.burger-icon {
  position: absolute;
  top: 15px;
  right: 20px;
  cursor: pointer;
}

.drawer-content {
  margin-top: 40px;
}

.custom-icon {
  background-color: #26272e;
  color: white;
}

.v-btn__overlay {
  display: none !important;
}
</style>
